define('TescoMobile_ClubCard/js/model/pdp-clubcard-price-provider',['./abstract-clubcard-price-provider', 'TescoMobile_Catalog/js/model/deal'], function (Component, deal) {
  'use strict';

  return Component.extend({
    defaults: {
      clubCardPrice: null,
      pufClubCardPrice: null,
      deviceClubCardPrice: null,
      deviceMonthlyPrice: null,
      calculatedDeviceMonthlyPrice: null,
      isTariffsContainClubCardPrice: null,
      ccaConfigClubCard: {},
      optionMap: {},
      imports: {
        selectedTariff: "tm-deal-tariff:selectedTariff",
        deviceSku: "tm-deal-device:deviceSku",
        selectedOptionId: "tm-cca-price:selectedOptionId",
        selectedOptionValue: "tm-cca-price:selectedOptionValue",
        deviceMonthlyPrice: "tm-cca-price:deviceMonthlyPrice",
        selectedPuf: "tm-cca-price:selectedPuf",
        selectedTenure: "tm-cca-price:selectedTenure"
      }
    },
    initialize: function () {
      this._super();
      this.selectedTariff.subscribe(this.handleStateUpdate, this);
      this.deviceSku.subscribe(this.handleStateUpdate, this);
      this.selectedPuf.subscribe(this.handleStateUpdate, this);
      this.selectedTenure.subscribe(this.handleStateUpdate, this);
      this.deviceMonthlyPrice.subscribe(this.handleStateUpdate, this);
      if (this.selectedTariff() && this.deviceSku() && this.selectedOptionId() && this.selectedOptionValue()) {
        this.handleStateUpdate();
      }
    },
    initObservable: function () {
      this._super().observe(['selectedTariff', 'deviceSku', 'selectedOptionId', 'selectedOptionValue', 'selectedPuf', 'selectedTenure', 'deviceClubCardPrice', 'deviceMonthlyPrice', 'pufClubCardPrice', 'calculatedDeviceMonthlyPrice', 'isTariffsContainClubCardPrice']);
      return this;
    },
    handleStateUpdate: function () {
      var _this$selectedTariff, _this$selectedTariff2, _this$selectedTariff3, _this$selectedTariff4, _this$selectedTariff5;
      let pufClubCardPrice = null;
      const optionId = this.selectedOptionId();
      const optionValue = this.selectedOptionValue();
      const hasDeviceClubCardPrice = optionId && optionValue && this.ccaConfigClubCard.hasOwnProperty(optionId) && this.ccaConfigClubCard[optionId].hasOwnProperty(optionValue) && Object.keys(this.ccaConfigClubCard[optionId][optionValue]['full'][0]).length > 0;
      const deviceMonthlyPrice = hasDeviceClubCardPrice ? this.ccaConfigClubCard[optionId][optionValue]['full'][0][this.selectedTenure()][this.selectedPuf()] : this.deviceMonthlyPrice();
      this.calculatedDeviceMonthlyPrice(deviceMonthlyPrice);
      if (this.selectedPuf() === 'all' && this.ccaConfigClubCard.hasOwnProperty(optionId) && this.ccaConfigClubCard[optionId].hasOwnProperty(optionValue) && this.ccaConfigClubCard[optionId][optionValue]['full_device_price'] > 0) {
        pufClubCardPrice = this.ccaConfigClubCard[optionId][optionValue]['full_device_price'];
      }
      const tariffPrice = (_this$selectedTariff = this.selectedTariff()) !== null && _this$selectedTariff !== void 0 && _this$selectedTariff.clubcard_price ? this.selectedTariff().clubcard_price : (_this$selectedTariff2 = this.selectedTariff()) === null || _this$selectedTariff2 === void 0 ? void 0 : _this$selectedTariff2.price;
      const tariffsContainClubCardPrice = this.tariffsContainClubCardPrice((_this$selectedTariff3 = this.selectedTariff()) === null || _this$selectedTariff3 === void 0 ? void 0 : _this$selectedTariff3.option_link);
      this.isTariffsContainClubCardPrice(tariffsContainClubCardPrice);
      if (tariffsContainClubCardPrice && hasDeviceClubCardPrice && ((_this$selectedTariff4 = this.selectedTariff()) === null || _this$selectedTariff4 === void 0 ? void 0 : _this$selectedTariff4.clubcard_price) > 0 || tariffsContainClubCardPrice && !hasDeviceClubCardPrice && ((_this$selectedTariff5 = this.selectedTariff()) === null || _this$selectedTariff5 === void 0 ? void 0 : _this$selectedTariff5.clubcard_price) > 0 || !tariffsContainClubCardPrice && hasDeviceClubCardPrice) {
        const clubCardPrice = [deviceMonthlyPrice, tariffPrice].map(p => parseFloat(p)).filter(p => !isNaN(p)).reduce((acc, p) => acc + p, 0.);
        this.clubCardPrice(clubCardPrice);
        this.deviceClubCardPrice(hasDeviceClubCardPrice ? deviceMonthlyPrice : null);
        this.pufClubCardPrice(pufClubCardPrice);
      } else {
        this.clubCardPrice(null);
        this.deviceClubCardPrice(null);
        this.pufClubCardPrice(null);
      }
    },
    tariffsContainClubCardPrice: function (optionLink) {
      return this.optionMap.tariff.options.filter(item => item.option_link === optionLink && (item === null || item === void 0 ? void 0 : item.clubcard_price)).length > 0;
    },
    getMonthlyTotal: function () {
      return parseFloat(this.deviceMonthlyPrice()) + parseFloat(this.selectedTariff().price);
    }
  });
});

